/* eslint-disable react-hooks/exhaustive-deps */
import { ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Tag, Drawer, Spin, notification } from 'antd';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SwitchLang from './SwitchLang';
import parse from 'html-react-parser';
import noImage from '../../../assets/Images/svg/noImage.svg';
import HistoryDrawer from '../ConsentHistory/HistoryDrawer';
import EmptyCustom from '../../../assets/Images/icons/emptyCustom';
import usePermission from '../../../hooks/usePermission';
export default function ConsentDetail({
    previewLang,
    setPreviewLang,
    currentSelectList,
    consentData,
    applicationList,
    loadingDetail,
    data,
}) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const boldLanguage = (text) => {
        let matchWord = text?.match(new RegExp(/lang="[A-Z]+"/));
        if (matchWord) {
            const arr = text.split(matchWord[0]);
            return (
                <>
                    {arr.map((item, index) => (
                        <span key={`code-${index}`}>
                            {item}
                            {index !== arr.length - 1 && <b>{matchWord}</b>}
                        </span>
                    ))}
                </>
            );
        } else return text;
    };

    // History
    const [visibleHistories, setVisibleHistories] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    const { isAuditor } = usePermission();

    return (
        <>
            {consentData ? (
                <div className="col-span-5">
                    <Spin spinning={loadingDetail}>
                        <div className="space-y-4">
                            <div className="bg-white rounded-md shadow-sm w-full p-6 ">
                                <div className="line-clamp-2 font-semibold text-base border-b-2 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                                    <p style={{ wordBreak: 'break-word' }}>
                                        {lang === 'en'
                                            ? consentData?.consentNameEn || '-'
                                            : consentData?.consentNameTh || '-'}
                                    </p>
                                </div>
                                <div hidden={isAuditor}>
                                    <div className="flex justify-between pt-4 items-center">
                                        <div className="font-semibold text-sm ">
                                            Consent Key
                                        </div>
                                        <div className="flex gap-2 items-center">
                                            <div className="flex-col gap-1 text-right">
                                                <div className="font-normal text-sm text-[#65707A]">
                                                    {t('Consent.Version')} :{' '}
                                                    {consentData?.version}
                                                </div>
                                                <div
                                                    className="text-[#F0536F] text-[12px] text-right"
                                                    hidden={
                                                        consentData?.version ===
                                                            consentData?.latestPublishedVersion ||
                                                        consentData?.status ===
                                                            'Draft'
                                                    }
                                                >
                                                    <span className="text-xl align-middle">
                                                        &#8226;
                                                    </span>{' '}
                                                    <span className='font-normal text-sm"'>
                                                        {t(
                                                            'Consent.DataChanged'
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <button
                                                className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm cursor-pointer"
                                                onClick={(e) => {
                                                    setIsChangeStatus(true);
                                                    setVisibleHistories(true);
                                                }}
                                            >
                                                <ClockCircleOutlined />
                                            </button>
                                        </div>
                                    </div>
                                    {consentData?.status === 'Draft' ? (
                                        <div className="rounded-md bg-gray-100 px-2 mt-4">
                                            <div className="py-2 flex justify-between items-center">
                                                <div className="h-10 overflow-y-auto flex justify-between items-center">
                                                    <div className="pl-4 text-[#B2B2B2]">
                                                        {t(
                                                            'Consent.CaseDraftKey'
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="pr-3 mt-2">
                                                    <svg
                                                        width={23}
                                                        height={23}
                                                        viewBox="0 0 23 23"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M5.75 5.87219V15.0938C5.74986 16.0062 6.09677 16.8845 6.72037 17.5505C7.34397 18.2165 8.19756 18.6205 9.108 18.6803L9.34375 18.6875H15.6889C15.5403 19.1078 15.265 19.4718 14.901 19.7292C14.537 19.9867 14.1021 20.1249 13.6562 20.125H8.625C7.48125 20.125 6.38435 19.6706 5.5756 18.8619C4.76685 18.0531 4.3125 16.9562 4.3125 15.8125V7.90625C4.31227 7.46016 4.4504 7.02497 4.70785 6.66067C4.96531 6.29637 5.32942 6.02089 5.75 5.87219ZM16.5312 2.875C17.1031 2.875 17.6516 3.10218 18.0559 3.50655C18.4603 3.91093 18.6875 4.45938 18.6875 5.03125V15.0938C18.6875 15.6656 18.4603 16.2141 18.0559 16.6184C17.6516 17.0228 17.1031 17.25 16.5312 17.25H9.34375C8.77188 17.25 8.22343 17.0228 7.81905 16.6184C7.41468 16.2141 7.1875 15.6656 7.1875 15.0938V5.03125C7.1875 4.45938 7.41468 3.91093 7.81905 3.50655C8.22343 3.10218 8.77188 2.875 9.34375 2.875H16.5312Z"
                                                            fill="#DBDBDB"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="rounded-md bg-gray-100 px-2 mt-4">
                                            <div className="py-2 flex justify-between items-center">
                                                <div className="h-10 overflow-y-auto flex justify-between items-center">
                                                    <div className="pl-4">
                                                        {boldLanguage(
                                                            consentData?.consentKey
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="pr-3 mt-2">
                                                    <CopyToClipboard
                                                        onCopy={() => {
                                                            notification[
                                                                'success'
                                                            ]({
                                                                message:
                                                                    'Copy to clipboard',
                                                                // description: 'Copy to clipboard',
                                                            });
                                                        }}
                                                        text={
                                                            consentData?.consentKey
                                                        }
                                                        className="cursor-pointer hover:opacity-80"
                                                    >
                                                        <svg
                                                            width={23}
                                                            height={23}
                                                            viewBox="0 0 23 23"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M5.75 5.87219V15.0938C5.74986 16.0062 6.09677 16.8845 6.72037 17.5505C7.34397 18.2165 8.19756 18.6205 9.108 18.6803L9.34375 18.6875H15.6889C15.5403 19.1078 15.265 19.4718 14.901 19.7292C14.537 19.9867 14.1021 20.1249 13.6562 20.125H8.625C7.48125 20.125 6.38435 19.6706 5.5756 18.8619C4.76685 18.0531 4.3125 16.9562 4.3125 15.8125V7.90625C4.31227 7.46016 4.4504 7.02497 4.70785 6.66067C4.96531 6.29637 5.32942 6.02089 5.75 5.87219ZM16.5312 2.875C17.1031 2.875 17.6516 3.10218 18.0559 3.50655C18.4603 3.91093 18.6875 4.45938 18.6875 5.03125V15.0938C18.6875 15.6656 18.4603 16.2141 18.0559 16.6184C17.6516 17.0228 17.1031 17.25 16.5312 17.25H9.34375C8.77188 17.25 8.22343 17.0228 7.81905 16.6184C7.41468 16.2141 7.1875 15.6656 7.1875 15.0938V5.03125C7.1875 4.45938 7.41468 3.91093 7.81905 3.50655C8.22343 3.10218 8.77188 2.875 9.34375 2.875H16.5312Z"
                                                                fill="#7B67FB"
                                                            />
                                                        </svg>
                                                    </CopyToClipboard>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="bg-white rounded-md shadow-sm w-full p-6 ">
                                <div className="font-semibold text-base pb-4">
                                    {t('Consent.ApplicationRelated')}
                                </div>
                                {applicationList?.map((res) => (
                                    <Tag
                                        // key={e.policyTypeId}
                                        className={`mr-2 mb-2 rounded-full px-3 py-2 border-solid border-[#DBDBDB] ${
                                            true === 1 ? 'select' : ''
                                        } space-x-4`}
                                    >
                                        <div className="flex gap-2 items-center">
                                            <img
                                                className="w-7 h-7 rounded-full object-cover"
                                                src={
                                                    res?.image
                                                        ? res?.image
                                                        : noImage
                                                }
                                                alt=""
                                            />
                                            <div className="font-semibold text-sm">
                                                {res?.applicationName}
                                            </div>
                                        </div>
                                    </Tag>
                                ))}
                            </div>
                            <div className="bg-white rounded-md shadow-sm w-full p-6 ">
                                <div className="flex items-center justify-between border-b-2 pb-4 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                                    <div className="">
                                        <SwitchLang
                                            previewLang={previewLang}
                                            setPreviewLang={setPreviewLang}
                                        />
                                    </div>
                                    <div className="font-semibold">
                                        {t('Consent.LastUpdate')} :{' '}
                                        <span className="text-sm font-normal">
                                            {consentData?.updateBy},{' '}
                                            {consentData?.updateDate}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center gap-1">
                                        <div className="mt-1.5">
                                            <svg
                                                width="16"
                                                height="15"
                                                viewBox="0 0 16 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M8 1.5C6.4087 1.5 4.88258 2.13214 3.75736 3.25736C2.63214 4.38258 2 5.9087 2 7.5C2 9.0913 2.63214 10.6174 3.75736 11.7426C4.88258 12.8679 6.4087 13.5 8 13.5C9.5913 13.5 11.1174 12.8679 12.2426 11.7426C13.3679 10.6174 14 9.0913 14 7.5C14 5.9087 13.3679 4.38258 12.2426 3.25736C11.1174 2.13214 9.5913 1.5 8 1.5V1.5ZM0.5 7.5C0.5 3.35775 3.85775 0 8 0C12.1422 0 15.5 3.35775 15.5 7.5C15.5 11.6422 12.1422 15 8 15C3.85775 15 0.5 11.6422 0.5 7.5Z"
                                                    fill={
                                                        consentData?.isConsented
                                                            ? '#1890FF'
                                                            : '#65707A'
                                                    }
                                                />
                                                <path
                                                    d="M8 6C8.19891 6 8.38968 6.07902 8.53033 6.21967C8.67098 6.36032 8.75 6.55109 8.75 6.75V11.25C8.75 11.4489 8.67098 11.6397 8.53033 11.7803C8.38968 11.921 8.19891 12 8 12C7.80109 12 7.61032 11.921 7.46967 11.7803C7.32902 11.6397 7.25 11.4489 7.25 11.25V6.75C7.25 6.55109 7.32902 6.36032 7.46967 6.21967C7.61032 6.07902 7.80109 6 8 6V6ZM9.125 4.125C9.125 4.42337 9.00647 4.70952 8.7955 4.9205C8.58452 5.13147 8.29837 5.25 8 5.25C7.70163 5.25 7.41548 5.13147 7.2045 4.9205C6.99353 4.70952 6.875 4.42337 6.875 4.125C6.875 3.82663 6.99353 3.54048 7.2045 3.3295C7.41548 3.11853 7.70163 3 8 3C8.29837 3 8.58452 3.11853 8.7955 3.3295C9.00647 3.54048 9.125 3.82663 9.125 4.125V4.125Z"
                                                    fill={
                                                        consentData?.isConsented
                                                            ? '#1890FF'
                                                            : '#65707A'
                                                    }
                                                />
                                            </svg>
                                        </div>

                                        {consentData?.isConsented ? (
                                            <div className="font-semibold text-sm text-[#1890FF] py-4">
                                                {t(
                                                    'Consent.RequiredConsentCheckDetail'
                                                )}
                                            </div>
                                        ) : (
                                            <div className="font-semibold text-sm text-[#65707A] py-4">
                                                {t(
                                                    'Consent.NotRequiredConsentCheckDetail'
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-sm font-medium">
                                        {t('Consent.DurationOfConsent')} :{' '}
                                        {consentData?.noExpirationDate
                                            ? t('Consent.NoExpiry')
                                            : `${
                                                  consentData?.consentDuration
                                              } ${t('Consent.Day')}`}
                                    </div>
                                </div>

                                <div className="rounded-md whitespace-pre-line border-solid border-[#DBDBDB] bg-[#F9FAFE] p-8">
                                    <div
                                        className="font-semibold text-sm whitespace-pre-wrap"
                                        style={{ wordBreak: 'break-word' }}
                                    >
                                        {previewLang === 'th'
                                            ? consentData?.consentNameTh || '-'
                                            : consentData?.consentNameEn || '-'}
                                    </div>
                                    {previewLang === 'en'
                                        ? parse(consentData?.purposeEn || '-')
                                        : parse(consentData?.purposeTh || '-')}
                                </div>
                            </div>
                            <div className="bg-white rounded-md shadow-sm w-full p-6 ">
                                <p className="text-[#1E1E1E] text-sm font-semibold">
                                    {t('Consent.Template Related')}
                                </p>
                                <div className="flex flex-wrap gap-2">
                                    {consentData.templateRelatedList?.map(
                                        (res) => (
                                            <Tag
                                                className={`rounded border-solid border-[#EDEEF9] bg-[#EDEEF9] mr-0`}
                                            >
                                                <div
                                                    className="text-sm text-purple-PHX font-normal inner-html-container py-2"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            lang === 'en'
                                                                ? res.templateNameEn
                                                                : res.templateNameTh,
                                                    }}
                                                ></div>
                                            </Tag>
                                        )
                                    )}

                                    {consentData?.templateRelatedList
                                        ?.length === 0 && (
                                        <p className="text-[#65707A] text-sm font-normal">
                                            {t('Consent.No template related')}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>
            ) : data?.length > 0 ? (
                <div className="bg-white rounded-b-md shadow-sm overflow-y-auto overflow-x-hidden h-[70vh] max-h-[70vh] col-span-5 w-full pb-5">
                    <div className="mt-48 ">
                        <EmptyCustom
                            text={lang === 'en' ? `No data` : `ไม่พบข้อมูล`}
                        />
                    </div>
                </div>
            ) : (
                <div className="bg-white rounded-b-md shadow-sm overflow-y-auto overflow-x-hidden h-[70vh] max-h-[70vh] col-span-5 w-full pb-5">
                    <div className="mt-48 ">
                        <EmptyCustom
                            text={
                                lang === 'en'
                                    ? `You can add your Consent and Terms & Conditions <br/>by pressing the <b>"Add"</b> button.`
                                    : `คุณสามารถสร้าง Consent และ Terms & Conditions <br/>โดยกดที่ปุ่ม <b>"เพิ่ม"</b>`
                            }
                        />
                    </div>
                </div>
            )}

            <Drawer
                title={
                    <div className="flex justify-between items-center">
                        <span className="text-purple text-[17px]">
                            {t('History')}
                        </span>
                        <button
                            onClick={(e) => setVisibleHistories(false)}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                }
                placement="right"
                onClose={() => setVisibleHistories(false)}
                closable={false}
                open={visibleHistories}
                className="history"
            >
                <HistoryDrawer
                    consentId={currentSelectList?.consentId}
                    setIsChangeStatus={setIsChangeStatus}
                    isChangeStatus={isChangeStatus}
                />
            </Drawer>
        </>
    );
}

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
